export default {
  name: 'project_event_start_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  default_value: 'default_values.project.event_start_date',
  static_options: {
    open_date: new Date(),
    show_time: 'project_display_settings.event.show_time'
  }
}